<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">Existing resources</p>
    </header>

    <section class="modal-card-body" >
        <div v-if="noResources">There are no existing image resources yet.</div>
        <main class="grid">
          <div v-for="(im,id) in libImages" :key="id">
            <img :src="im.url" @click="selectImage(im.url, im.name, im.file)" :class="im.url === selectedUrl ? 'active' : ''" style="cursor:pointer" alt="">
            <span class="caption" :style="im.url === selectedUrl ? 'font-weight: bold' : ''">{{im.name}}</span>
          </div>
        </main>
     </section>
     <footer v-if="!noResources" class="modal-card-foot" style="background-color:white;border-radius:0px">
         <p><b>Selected image: </b>{{selectedName}}</p>
  </footer>

    <footer class="modal-card-foot">
      <b-button type="is-info" v-if="!noResources" @click="uploadPicture()">Select</b-button>
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
    </footer>

  </div>
</template>

<script>

export default {
  name: 'PhotosLibrary',
  props: ['propParent'],
  data: () => {
    return {
      libImages: [],
      loadingComponent: null,
      selectedUrl: '',
      selectedName: '',
      selectedFile: null,
      noResources: false
    }
  },
  mounted: function () {
    this.loadingComponent = this.$buefy.loading.open()
    if (this.$store.state.playlists === null) {
      this.loadingComponent.close()
      this.noResources = true
    } else {
      var pl = this.$store.state.playlists
      var hasImages = false
      for (let playlist in pl) {
        var objectRef = Object.assign({}, this.$store.getters.getPlaylist(playlist))
        if (objectRef.items) {
          var itemsP = [...objectRef.items.filter(x => x)]
          var ext = null
          for (let i = 0; i < itemsP.length; i++) {
            if (itemsP[i].resourceName) {
              ext = itemsP[i].resourceName.split('.')[1]
              if (ext === 'jpg' || ext === 'png') {
                hasImages = true
                break
              }
            }
          }
        }
      }
      if (hasImages === false) {
        this.loadingComponent.close()
        this.noResources = true
      } else {
        for (let playlist in this.$store.state.playlists) {
          var playlistDirsRef = null
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + playlist)
          } else {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + playlist)
          }
          playlistDirsRef.listAll().then((dir) => {
            dir.items.forEach(fileRef => {
              fileRef.getDownloadURL().then((url) => {
                const xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = (event) => {
                  const blob = xhr.response
                  if (blob.type.split('/')[0] === 'image') {
                    var file = new File([blob], fileRef.name, {type: blob.type})
                    this.libImages.push({ 'name': fileRef.name, 'url': url, 'file': file })
                  }
                  this.loadingComponent.close()
                }
                xhr.open('GET', url)
                xhr.send()
              }).catch((error) => {
                this.globalLogger('error', error)
              })
            })
          })
        }
      }
    }
  },
  methods: {
    closeModal () {
      this.$parent.close()
    },
    selectImage (url, name, file) {
      this.selectedUrl = url
      this.selectedName = name
      this.selectedFile = file
    },
    uploadPicture () {
      this.propParent(this.selectedFile)
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap:20px;
  align-items: center;
  }
.grid img {
  box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
  max-width: 100%;
}
.active {
  border: 3.2px solid #3e8ed0;
}
.caption {
    display: block;
    font-size: 10pt;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/playlists/items/PhotosLibrary.vue